// TODO: Once forms get more complex, we might want to add logic to trigger errors more specifically
class DomaineInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.error = this.querySelector('[data-error]');
    this.errorText = this.error.textContent;
  }

  connectedCallback() {
    if (this.input.hasAttribute('mask')) {
      this.input.addEventListener('input', (e) => {
        if (e.inputType !== 'deleteContentBackward' && e.inputType !== 'deleteContentForward') {
          this.addMask(e);
        }
      });
    }
  }

  disconnectedCallback() {
    this.input.removeEventListener('input', this.addMask);
  }

  // watch for error attribute changes
  static get observedAttributes() {
    return ['error'];
  }

  // handle error attribute changes
  // eslint-disable-next-line no-unused-vars
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'error') {
      this.refreshErrorText();
    }
  }

  // This make sure that the screen reader reads the error message
  refreshErrorText() {
    if (this.error.textContent === '') return;
    this.error.textContent = '';
    this.error.textContent = this.errorText;
  }

  addMask = (e) => {
    const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = `${x[1] ? `(${x[1]}) ` : ''}${x[2]}${x[3] ? `-${x[3]}` : ''}`;
  };
}

customElements.define('domaine-input', DomaineInput);

export default DomaineInput;
